export function useSearchHandler(catalogState: any, catalogDispatch: any, group: string) {
  return (searchQuery: string) => {
    const updatedView = {
      [group]: {
        ...catalogState.view[group],
        filters: {
          ...catalogState.view[group].filters,
          searchQuery,
        },
        sort: 'default', // removing current sort to allow the user see the best match for the search
      },
    };

    catalogDispatch({
      type: 'VIEW',
      payload: {
        ...updatedView,
      },
    });

    sessionStorage.setItem(
      'catalogView',
      JSON.stringify({
        ...catalogState.view,
        ...updatedView,
      })
    );
  };
}

export default useSearchHandler;
